// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './components/App'
import jquery from 'vue-jquery'
import locale from 'element-ui/lib/locale/lang/pt-br'
import router from './utils/router'
import ElementUI from 'element-ui'
import MenuIcon from 'vue-material-design-icons-size/Menu.vue'
import Vue from 'vue'
import ApiService from '@/utils/services/api.service'
import VueTheMask from 'vue-the-mask'
import fullscreen from 'vue-fullscreen'

// CSS Imports
import '@/theme/main.sass'
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-material-design-icons-size/styles.css'

Vue.config.productionTip = false

Vue.use(VueTheMask)
Vue.use(jquery)
Vue.use(fullscreen)
Vue.use(ElementUI, { locale })
ApiService.init()

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App, MenuIcon },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js